<template>
  <div class="contest">比赛</div>
</template>

<script>
export default {
  name: "Contest",
  components: {},
  data() {
    return {};
  },
  methods: {},
};
</script>

<style land="less" scoped>
</style>